/* ============================================================
   Esqueleto de carregamento

   Só existe onde a espera é PERCEBIDA e a forma do que vem é conhecida:
   o feed e o placar. O resto do app segue com o `Spinner`, que é honesto
   quando não se sabe o que vai chegar — esqueleto em toda tela é trabalho
   que não se paga e vira mentira quando a lista volta vazia.

   O motivo não é só perceber a espera: o esqueleto RESERVA A CAIXA da
   foto, então o feed não pula quando a imagem chega. É o mesmo argumento
   do `aspect-ratio` no anúncio, e vale igual para o prato.

   `aria-hidden` porque para quem usa leitor de tela isto é ruído: quem
   anuncia a espera é o `role="status"` do container.
   ============================================================ */

function Barra({ largura, altura = 13 }: { largura: string; altura?: number }) {
  return <span className="esq-barra" style={{ width: largura, height: altura }} />;
}

/** Um card do feed, na mesma caixa que o `.prato-card` de verdade ocupa. */
export function EsqueletoDoFeed({ quantos = 2 }: { quantos?: number }) {
  return (
    <div role="status" aria-label="Carregando os pratos">
      {Array.from({ length: quantos }, (_, i) => (
        <div key={i} className="prato-card esqueleto" aria-hidden="true">
          <div className="esq-bloco prato-foto" />
          <div className="prato-corpo">
            <Barra largura="62%" altura={17} />
            <div className="esq-linha"><Barra largura="38%" /></div>
          </div>
        </div>
      ))}
    </div>
  );
}

/** Linhas de pessoa do placar: avatar redondo, nome e subtítulo. */
export function EsqueletoDePlacar({ quantos = 5 }: { quantos?: number }) {
  return (
    <div className="card lista-crua" role="status" aria-label="Carregando o placar">
      {Array.from({ length: quantos }, (_, i) => (
        <div key={i} className="rank-row esqueleto" aria-hidden="true">
          <span className="esq-bloco esq-avatar" />
          <div className="rank-main">
            <Barra largura="52%" altura={15} />
            <div className="esq-linha"><Barra largura="30%" altura={12} /></div>
          </div>
        </div>
      ))}
    </div>
  );
}
